module.exports = __webpack_public_path__ + "img/product21.7bf961c5.png";